import { getOS, DeviceGrades } from './deviceDetection'

// iPhone model checks.
export const getiPhoneModel = function() {
    var details = {
        deviceName: '',
        type: '',
        platform: '',
        browser: '',
        grade: 'N/A',
        gpu: '',
        os: getOS(),
        ram: '',
        webVR: false,
    }
    details.resolution = window.screen.height + 'x' + window.screen.width

    // Create a canvas element which can be used to retrieve information about the GPU.
    var canvas = document.createElement('canvas')
    if (canvas) {
        var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        if (context) {
            var info = context.getExtension('WEBGL_debug_renderer_info')
            if (info) {
                var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL)
                details.gpu = renderer
            }
        }
    }

    // iPhone X
    if (window.screen.height / window.screen.width == 812 / 375 && window.devicePixelRatio == 3) {
        details.type = 'iphone'
        details.deviceName = 'iPhone X'
        details.grade = DeviceGrades.A
        // iPhone 6+/6s+/7+ and 8+
    } else if (window.screen.height / window.screen.width == 736 / 414 && window.devicePixelRatio == 3) {
        details.type = 'iphone'
        switch (renderer) {
            default:
                details.deviceName = 'iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus'
                details.grade = DeviceGrades.A
                break
            case 'Apple A8 GPU':
                details.deviceName = 'iPhone 6 Plus'
                details.grade = DeviceGrades.A
                break
            case 'Apple A9 GPU':
                details.deviceName = 'iPhone 6s Plus'
                details.grade = DeviceGrades.A
                break
            case 'Apple A10 GPU':
                details.deviceName = 'iPhone 7 Plus'
                details.grade = DeviceGrades.A
                break
            case 'Apple A11 GPU':
                details.deviceName = 'iPhone 8 Plus'
                details.grade = DeviceGrades.A
        }
        // iPhone 6+/6s+/7+ and 8+ in zoom mode
    } else if (window.screen.height / window.screen.width == 667 / 375 && window.devicePixelRatio == 3) {
        details.type = 'iphone'
        switch (renderer) {
            default:
                details.deviceName = 'iPhone 6 Plus, 6s Plus, 7 Plus or 8 Plus (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A8 GPU':
                details.deviceName = 'iPhone 6 Plus (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A9 GPU':
                details.deviceName = 'iPhone 6s Plus (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A10 GPU':
                details.deviceName = 'iPhone 7 Plus (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A11 GPU':
                details.deviceName = 'iPhone 8 Plus (display zoom)'
                details.grade = DeviceGrades.A
        }
        // iPhone 6/6s/7 and 8
    } else if (window.screen.height / window.screen.width == 667 / 375 && window.devicePixelRatio == 2) {
        details.type = 'iphone'
        switch (renderer) {
            default:
                details.deviceName = 'iPhone 6, 6s, 7 or 8'
                details.grade = DeviceGrades.A
                break
            case 'Apple A8 GPU':
                details.deviceName = 'iPhone 6'
                details.grade = DeviceGrades.A
                break
            case 'Apple A9 GPU':
                details.deviceName = 'iPhone 6s'
                details.grade = DeviceGrades.A
                break
            case 'Apple A10 GPU':
                details.deviceName = 'iPhone 7'
                details.grade = DeviceGrades.A
                break
            case 'Apple A11 GPU':
                details.deviceName = 'iPhone 8'
                details.grade = DeviceGrades.A
        }
        // iPhone 5/5C/5s/SE or 6/6s/7 and 8 in zoom mode
    } else if (window.screen.height / window.screen.width == 1.775 && window.devicePixelRatio == 2) {
        details.type = 'iphone'
        switch (renderer) {
            default:
                const h = parseInt(window.screen.height)
                if (h <= 640) {
                    details.deviceName = 'iPhone 5, 5C, 5S, SE'
                    details.grade = DeviceGrades.C
                } else if (h <= 750) {
                    details.deviceName = 'iPhone 6, 6s, 7 and 8'
                    details.grade = DeviceGrades.A
                } else {
                    details.deviceName = 'iPhone 6, 6s, 7 and 8'
                    details.grade = DeviceGrades.A
                }

                break
            case 'PowerVR SGX 543':
                details.deviceName = 'iPhone 5 or 5c'
                break
            case 'Apple A7 GPU':
                details.deviceName = 'iPhone 5s'
                details.grade = DeviceGrades.C
                break
            case 'Apple A8 GPU':
                details.deviceName = 'iPhone 6 (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A9 GPU':
                details.deviceName = 'iPhone SE or 6s (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A10 GPU':
                details.deviceName = 'iPhone 7 (display zoom)'
                details.grade = DeviceGrades.A
                break
            case 'Apple A11 GPU':
                details.deviceName = 'iPhone 8 (display zoom)'
                details.grade = DeviceGrades.A
        }
        // iPhone 4/4s
    } else if (window.screen.height / window.screen.width == 1.5 && window.devicePixelRatio == 2) {
        details.type = 'iphone'
        switch (renderer) {
            default:
                details.deviceName = 'iPhone 4 or 4s'
                break
            case 'PowerVR SGX 535':
                details.deviceName = 'iPhone 4'
                break
            case 'PowerVR SGX 543':
                details.deviceName = 'iPhone 4s'
        }
        // iPhone 1/3G/3GS
    } else if (window.screen.height / window.screen.width == 1.5 && window.devicePixelRatio == 1) {
        details.type = 'iphone'
        switch (renderer) {
            default:
                details.deviceName = 'iPhone 1, 3G or 3GS'
                break
            case 'ALP0298C05':
                details.deviceName = 'iPhone 3GS'
                break
            case 'S5L8900':
                details.deviceName = 'iPhone 1, 3G'
        }
    }

    //Last we are just making wild guess here.
    if (details.deviceName == '' && window.devicePixelRatio >= 2) {
        details.type = 'iphone'
        details.deviceName = 'iPhone1'
        details.grade = DeviceGrades.A
    }

    return details
}

export const getiPadModel = function() {
    var details = {
        deviceName: 'unknown',
        type: 'unknown',
        platform: 'unknown',
        browser: 'unknown',
        grade: 'NOT-TESTED',
        gpu: 'unknown',
        os: getOS(),
        ram: 'unknown',
        webVR: false,
    }

    // Create a canvas element which can be used to retreive information about the GPU.
    var canvas = document.createElement('canvas')
    if (canvas) {
        var context = canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
        if (context) {
            var info = context.getExtension('WEBGL_debug_renderer_info')
            if (info) {
                var renderer = context.getParameter(info.UNMASKED_RENDERER_WEBGL)
                details.gpu = renderer
            }
        }
    }

    details.resolution = window.screen.height + 'x' + window.screen.width
    if (window.screen.height / window.screen.width == 1024 / 768) {
        // iPad, iPad 2, iPad Mini
        if (window.devicePixelRatio == 1) {
            switch (renderer) {
                default:
                    details.deviceName = 'iPad, iPad 2, iPad Mini'
                    details.type = 'ipad'
                    break
                case 'PowerVR SGX 535':
                    details.grade = 'F'
                    details.deviceName = 'iPad'
                    details.type = 'ipad'
                    break
                case 'PowerVR SGX 543':
                    details.grade = 'F'
                    details.deviceName = 'iPad 2 or Mini'
                    details.type = 'ipad'
            }
            // iPad 3, 4, 5, 6, Mini 2, Mini 3, Mini 4, Air, Air 2
        } else {
            switch (renderer) {
                default:
                    details.grade = 'F'
                    details.deviceName = 'iPad 3, 4, 5, 6, Mini 2, Mini 3, Mini 4, Air, Air 2'
                    details.type = 'ipad'
                    break
                case 'PowerVR SGX 543':
                    details.grade = 'F'
                    details.type = 'ipad'
                    details.deviceName = 'iPad 3'
                    break
                case 'PowerVR SGX 554':
                    details.grade = DeviceGrades.C
                    details.type = 'ipad'
                    details.deviceName = 'iPad 4'
                    break
                case 'Apple A7 GPU':
                    details.grade = DeviceGrades.C
                    details.type = 'ipad'
                    details.deviceName = 'iPad Air, Mini 2, Mini 3'
                    break
                case 'Apple A8X GPU':
                    details.grade = DeviceGrades.A
                    details.type = 'ipad'
                    details.deviceName = 'iPad Air 2'
                    break
                case 'Apple A8 GPU':
                    details.grade = DeviceGrades.A
                    details.type = 'ipad'
                    details.deviceName = 'iPad Mini 4'
                    break
                case 'Apple A9 GPU':
                    details.grade = DeviceGrades.A
                    details.type = 'ipad'
                    details.deviceName = 'iPad 5, Pro 9.7'
                    break

                case 'Apple A9X GPU':
                    details.grade = DeviceGrades.A
                    details.type = 'ipad'
                    details.deviceName = 'iPad Pro'
                    break
                case 'Apple A10 GPU':
                    details.grade = DeviceGrades.A
                    details.type = 'ipad'
                    details.deviceName = 'iPad 6'
                    break
            }
        }
        // iPad Pro 10.5
    } else if (window.screen.height / window.screen.width == 1112 / 834) {
        details.deviceName = 'iPad Pro 10.5'
        details.grade = DeviceGrades.A
        // iPad Pro 12.9, Pro 12.9 (2nd Gen)
    } else if (window.screen.height / window.screen.width == 1366 / 1024) {
        switch (renderer) {
            default:
                details.grade = DeviceGrades.A
                details.type = 'ipad'
                details.deviceName = 'iPad Pro 12.9, Pro 12.9 (2nd Gen)'
                break
            case 'Apple A10X GPU':
                details.grade = DeviceGrades.A
                details.type = 'ipad'
                details.deviceName = 'iPad Pro 12.9 (2nd Gen)'
                break
            case 'Apple A9 GPU':
                details.grade = DeviceGrades.A
                details.type = 'ipad'
                details.deviceName = 'iPad Pro 12.9'
        }
    }

    //Last we are just making wild guess here.
    if (details.deviceName == '' && window.devicePixelRatio >= 2) {
        details.type = 'ipad'
        details.deviceName = 'iPad'
        details.grade = DeviceGrades.A
    }

    return details
}
